import React, { useMemo } from 'react';
import { formatAmount } from '../../../../utils';

const ModalSupplies = ({ item, onClose }) => {
  const suppliers = useMemo(() => {
    const providerIds = [];

    item?.supplies?.forEach(s => {
      if (providerIds.includes(s.supplier_id)) return;
      providerIds.push(s.supplier_id);
    });

    return providerIds?.map(id => {
      const name = item?.supplies?.find(s => s.supplier_id === id)?.supplier?.name;
      const amount = item?.supplies
        ?.filter(y => y.supplier_id === id)
        ?.reduce((acc, curr) => acc + curr.cost, 0);

      return {
        name,
        amount,
        amount_local: amount * item?.cost_conversion,
      }
    });
  }, [item]);

  return (
    <div className="w-[40rem] mx-auto bg-white p-6 rounded-2xl font-sans antialiased selection:bg-orange-100 relative">
      <button
        type="button"
        className="p-1.5 rounded-full hover:bg-gray5 transition-colors absolute top-2 right-2"
        onClick={onClose}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="mb-6">
        <h3 className="text-xl font-bold mb-4 text-gray-900">Detalles (Insumos/Repuestos)</h3>
      </div>

      <div className="mb-6 space-y-3">
        <div className="grid grid-cols-6 gap-2 text-sm text-default font-semibold items-end">
          <span>Repuesto / Insumo</span>
          <span>Cantidad</span>
          <span>Uni. Medida</span>
          <span>Costo ($)</span>
          <span>Costo (Bs)</span>
          <span>Proveedor</span>
        </div>
        {item?.supplies?.map((s, index) => (
          <div key={index} className="bg-[#F2F2F2] rounded-lg p-4 grid grid-cols-6 gap-2 text-sm">
            <span className="font-bold text-orange">{ s.supply?.name }</span>
            <span>{ s.quantity }</span>
            <span>{ s.measuring_unit?.name }</span>
            <span className="font-bold">{ formatAmount(s.cost) }</span>
            <span className="font-bold">{ formatAmount(s.cost * item.cost_conversion) }</span>
            <span>{ s.supplier?.name || '--' }</span>
          </div>
        ))}
      </div>

      <div className="mb-8">
        <h4 className="text-xl font-bold mb-4 text-gray-900">Gastos por repuestos e Insumos</h4>

        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <span className="text-lg font-semibold">Total por Categoría</span>
          </div>
          <div className="text-right">
            <div className="text-xl font-bold">{ formatAmount(item?.cost_total, '$') }</div>
            <div className="font-medium opacity-90">{ formatAmount(item?.cost_total_local, 'Bs') }</div>
          </div>
        </div>

        <hr className="border-default" />

        <div className="space-y-4 mt-2">
          <span className="text-lg font-semibold">Total por Proveedor</span>

          {suppliers.map((prov, index) => (
            <div key={index} className="border-b border-default last:border-none pb-3 last:pb-0">
              <div className="flex justify-between items-center">
                <span className="text-base font-semibold">{ prov.name }</span>
                <div className="text-right">
                  <span className="text-base font-bold block">{ formatAmount(prov.amount, '$') }</span>
                  <span>{ formatAmount(prov.amount_local, 'Bs') }</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center items-center gap-6 pt-2">
        <button
          onClick={onClose}
          className="text-[#A3A3A3] font-bold text-lg hover:text-gray-600 transition-all duration-200"
        >
          Cerrar
        </button>
      </div>

    </div>
  )
}

export default ModalSupplies